import _ from 'lodash';

export const getTradeMethodOptionIds = (options) => _(options).map('id').flatten().value();
